import { useState, useEffect } from 'react';
import { getDefectStatuses } from 'services/clients/sites/siteApplications/defectStatuses';
import { useDispatch } from 'react-redux';
import { showError } from '../../../../../redux/common/actions';
import { getLocalStorageData } from 'helpers/utils';
import { SHOW_ALL_OPTION } from '../../constants';

export const useDefectStatus = (showAll = true) => {
	const dispatch = useDispatch();
	const [defectStatuses, setDefectStatuses] = useState([]);
	const userData = getLocalStorageData("me");
	const siteAppID = userData?.siteAppID;

	// Define group options once to avoid duplication
	const groupOptions = [
		{ id: "C", name: "All Complete", statusType: "C", groupBy: "All Complete" },
		{ id: "O", name: "All Outstanding", statusType: "O", groupBy: "All Outstanding" },
	];

	const buildStatusOptions = (processedData = []) => {
		return showAll 
			? [SHOW_ALL_OPTION, ...groupOptions, ...processedData]
			: [...groupOptions, ...processedData];
	};

	useEffect(() => {
		const loadDefectStatuses = async () => {
			try {
				const response = await getDefectStatuses(siteAppID);
				if (response?.status && response?.data) {
					const fetchedStatuses = response.data || [];
					
					// Add the grouped statuses based on type character
					const processedData = fetchedStatuses.map((status) => {
						let groupName;
						if (status.type === "C") {
							groupName = "All Complete";
						} else if (status.type === "O") {
							groupName = "All Outstanding";
						}
						
						return { ...status, groupBy: groupName };
					});
					
					setDefectStatuses(buildStatusOptions(processedData));
				} else {
					// Fallback for unsuccessful response
					setDefectStatuses(buildStatusOptions());
				}
			} catch (error) {
				console.error('Failed to fetch defect statuses:', error);
				// Set fallback data on error
				setDefectStatuses(buildStatusOptions());
				dispatch(
					showError(
						error?.response?.data?.detail || 'Failed to fetch defect statuses'
					)
				);
			}
		};

		if (siteAppID) {
			loadDefectStatuses();
		} else {
			// Set default data if no siteAppID
			setDefectStatuses(buildStatusOptions());
		}
	}, [siteAppID, showAll, dispatch]);

	// Ensure we always return an array
	return Array.isArray(defectStatuses) ? defectStatuses : [];
};

// Export group members for external use
export const GROUP_MEMBERS = [
	{ id: "C", name: "All Complete", statusType: "C", groupBy: "All Complete" },
	{ id: "O", name: "All Outstanding", statusType: "O", groupBy: "All Outstanding" },
];